import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Table,
  ProgressBar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import NoRecordsFound from "elements/NoRecordsFound";
import GameItem from "elements/games_elements/GameItem";
import LoadMore from "elements/LoadMore";
import api from "services/api";
import moment from "moment";
import DOMPurify from "dompurify";
import { __ } from "services/Translator";
import { Helmet } from "react-helmet";
import RemainingTime from "elements/RemainingTime";

export default function Races(props) {
  const [showDetails, setShowDetails] = useState(false);
  const [raceTab, setRaceTab] = useState("In Progress");
  const [showLeaderBoard, setShowLeaderBoard] = useState(false);

  const [races, setRaces] = useState([]);
  const [leaderBoard, setLeaderBoard] = useState([]);
  const [campaignDetails, setCampaignDetails] = useState("");
  const [campaignGames, setCampaignGames] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [gameLoaded, setGameLoaded] = useState(0);
  const [totalGame, setTotalGame] = useState(0);

  const getRaces = async (raceStatus) => {
    var response = await api.get("/race/list/" + raceStatus);
    if (response.status === 200) {
      setRaces(response.data);
    }
  };

  const [racePage, setRacePage] = useState(null);
  const getRacePage = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "races",
    });
    if (response.status === 200) {
      setRacePage(response.data);
    }
  };
  useEffect(() => {
    getRacePage();
  }, []);

  useEffect(() => {
    if (raceTab === "In Progress") {
      getRaces("active");
    } else {
      getRaces("inactive");
    }
  }, [raceTab]);

  const openLeaderBoard = async (id) => {
    setShowLeaderBoard(true);
    var response = await api.get("/race/leaderboard/" + id);
    if (response.status === 200) {
      setLeaderBoard(response.data);
    }
  };

  const openDetails = async (campaign) => {
    setShowDetails(true);
    setCampaignDetails(campaign);
    getRaceGames(campaign.id, 1);
  };

  const getRaceGames = async (campaignId, page) => {
    var response = await api.get("/race/games/" + campaignId + "/" + page);
    if (response.status === 200) {
      setCampaignGames([...campaignGames, ...response.data.games]);
      setGameLoaded(campaignGames.length + response.data.games.length);
      setPagination(response.data.paginationData);
      setTotalGame(response.data.gameCount);
    }
  };

  const onPageChange = (page) => {
    getRaceGames(campaignDetails.id, page);
  };

  const calculateGridColumnsForGameImage = (gamesCount) => {
    if (!gamesCount) {
      return "repeat(1, 1fr)";
    }
    if (gamesCount > 3) {
      gamesCount = 3;
    }
    return "repeat(" + gamesCount + ", 1fr)";
  };

  const renderHTML = (rawHTML) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(rawHTML) },
    });

  return (
    <>
      <Helmet>
        <title>
          {__(
            "Joker Casino | Race against other players for your chance to win a share of the prize pool!"
          )}
        </title>
        <meta
          name="description"
          content={__(
            "Joker Casino! View our current and upcoming tournaments where you take on other players - you all start with the same amount of chips, whoever ends with the most wins!"
          )}
        />
      </Helmet>
      <div className="container-xxl">
        <section className={"banner raceBanner "}>
          <div className="single_banner">
            <div className="banner_middle">
              {/* <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div> */}
              <div className="headline">
                {__("Joker openning")} <br /> {__("Tournament")}
              </div>
              <div className="quotedHeadline">{__("No Any Slot Game.")}</div>
              <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
                {__(
                  "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on."
                )}
              </div>

              <div className="banner_count ">
                {props.totals && (
                  <>
                    <div className="count_area">
                      <div className="single_count">
                        <div className="number">
                          {props.totals.totalPlayers}+
                        </div>
                        <div className="paragraph">{__("Players Online")}</div>
                      </div>
                      <div className="single_count">
                        <div className="number">{props.totals.totalGames}+</div>
                        <div className="paragraph">{__("Games")}</div>
                      </div>
                    </div>
                  </>
                )}
                {props.isAuthenticated ? (
                  <Link
                    to="/games/slots"
                    className={"angle_btn " + props.landingType}
                  >
                    {__("Play Now")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="red"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  </Link>
                ) : (
                  <Link
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                    }}
                    className={"angle_btn " + props.landingType}
                  >
                    {__("Sign Up Now")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="red"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  </Link>
                )}
              </div>
            </div>
            <div className={"banner_img " + props.landingType}>
              {!props.isMobileDeviceByViewPort && (
                <img
                  alt="game image"
                  src={
                    require("assets/images/banners/racing-banner.png").default
                  }
                />
              )}
              {props.isMobileDeviceByViewPort && (
                <img
                  alt="game image"
                  src={
                    require("assets/images/banners/races-banner-mobile.png")
                      .default
                  }
                />
              )}
            </div>
            {/* {props.isMobileDeviceByViewPort && (
              <>
                <div className="loginBtnArea">
                  {props.isAuthenticated ? (
                    <Link
                      to="/games/slots"
                      className={"angle_btn " + props.landingType}
                    >
                      {__("Play Now")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="red"
                        class="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </Link>
                  ) : (
                    <Link
                      onClick={() => {
                        props.setModalSignUpPropsData(true);
                      }}
                      className={"angle_btn " + props.landingType}
                    >
                      {__("Sign Up Now")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="red"
                        class="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </Link>
                  )}
                </div>

                <div className="banner_count padding_top_bottom_30">
                  {props.totals && (
                    <>
                      <div className="single_count">
                        <div className="number">
                          {props.totals.totalPlayers}+
                        </div>
                        <div className="paragraph">{__("Players Online")}</div>
                      </div>
                      <div className="single_count">
                        <div className="number">{props.totals.totalGames}+</div>
                        <div className="paragraph">{__("Games")}</div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )} */}
          </div>

          {!props.isMobileDeviceByViewPort && (
            <div className="banner_features_list">
              <div className="single_item">{__("01. Best Quality")}</div>
              <div className="single_item">{__("02. Secure Payment")}</div>
              <div className="single_item">{__("03. Fast Pay - Outs")}</div>
              <div className="single_item">{__("04. Return Guarantee")}</div>
              <div className="single_item">{__("05. Support Customer")}</div>
            </div>
          )}
        </section>
      </div>
      <div className="container-xxl">
        <div className="racesPage">
          <br />
          <br />

          <ul className="raceMenu">
            <li>
              <Link
                onClick={() => {
                  setRaceTab("In Progress");
                }}
                className={
                  raceTab === "In Progress"
                    ? "inProgressBtn active"
                    : "inProgressBtn"
                }
              >
                {__("In Progress")}
              </Link>
            </li>
            <li>
              <Link
                onClick={() => {
                  setRaceTab("Ended");
                }}
                className={raceTab === "Ended" ? "endedBtn active" : "endedBtn"}
              >
                {__("Ended")}
              </Link>
            </li>
          </ul>
          <div className="racesArea">
            {/* <div className="singleRace">
              <section className="banner_bottom">
                <div className="banner_image">
                  {!props.isMobileDeviceByViewPort && (
                    <img
                      alt="game image"
                      style={{ width: "110%" }}
                      src={
                        require("assets/images/races/car-banner.png").default
                      }
                    />
                  )}
                  {props.isMobileDeviceByViewPort && (
                    <img
                      alt="game image"
                      src={
                        require("assets/images/races/car-banner-mobile.png")
                          .default
                      }
                    />
                  )}

                  <div className="text_block">
                    <div className="title italic">
                      {__("GET YOUR WELCOME PACKAGE")}
                    </div>

                    <div className="countdownArea">
                      <ul>
                        <li>356</li>
                        <li className="colon">:</li>
                        <li>365</li>
                        <li className="colon">:</li>
                        <li>365</li>
                        <li className="colon">:</li>
                        <li>365</li>
                      </ul>
                    </div>

                    <Link
                      onClick={() => {
                        // openLeaderBoard(item.id);
                      }}
                      className={"angle_btn " + props.landingType}
                    >
                      {__("Leaderboards")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="red"
                        class="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </section>
            </div> */}
            {races.length ? (
              <>
                {races.map((item, index) => (
                  <div className="singleRace">
                    <section className="banner_bottom">
                      <div className="banner_image">
                        {!props.isMobileDeviceByViewPort && (
                          <img
                            alt="game image"
                            style={{ width: "110%" }}
                            src={
                              require("assets/images/races/car-banner.png")
                                .default
                            }
                          />
                        )}
                        {props.isMobileDeviceByViewPort && (
                          <img
                            alt="game image"
                            src={
                              require("assets/images/races/car-banner-mobile.png")
                                .default
                            }
                          />
                        )}

                        <div className="text_block race_text_block">
                          {/* <div className="race_date">
                            {moment(
                              item.expiry_date,
                              "YYYY-MM-DD HH:mm:ss"
                            ).format("MMMM Do YYYY, hh:mm:ss A")}
                          </div> */}
                          <div className="title-area">
                            <div className="title italic">
                              {/* {__("GET YOUR WELCOME PACKAGE")} */}
                              {item.lang?.title}
                            </div>
                            <div className="info_btn">
                              <OverlayTrigger
                                overlay={
                                  <Tooltip>
                                    {/* {item.lang?.campaign_information} */}
                                    {renderHTML(item.lang?.description)}
                                  </Tooltip>
                                }
                              >
                                <svg
                                  width="31"
                                  height="30"
                                  viewBox="0 0 31 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M15.4994 0C7.21619 0 0.5 6.71619 0.5 14.9994C0.5 23.2825 7.21619 30 15.4994 30C23.7825 30 30.5 23.2825 30.5 14.9994C30.5 6.71619 23.7825 0 15.4994 0ZM18.6219 23.247C17.8498 23.5517 17.2352 23.7829 16.7743 23.9429C16.3146 24.1029 15.78 24.1829 15.1717 24.1829C14.2371 24.1829 13.5095 23.9543 12.9914 23.4984C12.4733 23.0425 12.2156 22.4648 12.2156 21.7625C12.2156 21.4895 12.2346 21.2102 12.2727 20.9257C12.3121 20.6413 12.3743 20.3213 12.4594 19.9619L13.4257 16.5486C13.5108 16.221 13.5844 15.9098 13.6429 15.6203C13.7013 15.3283 13.7292 15.0603 13.7292 14.8165C13.7292 14.3822 13.639 14.0775 13.46 13.906C13.2784 13.7346 12.9368 13.6508 12.4276 13.6508C12.1787 13.6508 11.9222 13.6876 11.6594 13.7651C11.399 13.8451 11.173 13.9175 10.9876 13.9886L11.2429 12.9371C11.8752 12.6794 12.481 12.4584 13.0587 12.2756C13.6365 12.0902 14.1825 11.9987 14.6968 11.9987C15.6251 11.9987 16.3413 12.2248 16.8454 12.6717C17.347 13.12 17.5997 13.7029 17.5997 14.419C17.5997 14.5676 17.5819 14.8292 17.5476 15.2025C17.5133 15.5771 17.4486 15.9187 17.3546 16.2324L16.3933 19.6356C16.3146 19.9086 16.2448 20.221 16.1813 20.5702C16.119 20.9194 16.0886 21.186 16.0886 21.3651C16.0886 21.8171 16.1889 22.1257 16.3921 22.2895C16.5927 22.4533 16.9444 22.5359 17.4422 22.5359C17.6771 22.5359 17.94 22.494 18.2371 22.4127C18.5317 22.3314 18.7451 22.259 18.8797 22.1968L18.6219 23.247ZM18.4517 9.43365C18.0035 9.85016 17.4638 10.0584 16.8327 10.0584C16.2029 10.0584 15.6594 9.85016 15.2073 9.43365C14.7578 9.01714 14.5305 8.51048 14.5305 7.91873C14.5305 7.32825 14.759 6.82032 15.2073 6.4C15.6594 5.97841 16.2029 5.76889 16.8327 5.76889C17.4638 5.76889 18.0048 5.97841 18.4517 6.4C18.9 6.82032 19.1248 7.32825 19.1248 7.91873C19.1248 8.51175 18.9 9.01714 18.4517 9.43365Z" />
                                </svg>
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="details">
                            {item.lang?.campaign_information}
                          </div>

                          {item.ending_in ? (
                            <>
                              <div className="countdown">
                                <div className="ending_text">
                                  {__("ENDING IN")}
                                </div>
                                <div className="ending_clock">
                                  <RemainingTime
                                    timestamp={item.ending_in}
                                    endTime={new Date(item.expiry_date)}
                                  />
                                </div>
                                <div className="ending_text">
                                  {__("MIN BET")} : ${item.minimum_wager}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="title small">
                                {__("The race has")}
                              </div>
                              <div className="title colored">
                                {__("Finished")}
                              </div>
                              <div className="title uppercase small">
                                {__("MIN BET")} : ${item.minimum_wager}
                              </div>
                            </>
                          )}
                          <br />

                          <Link
                            onClick={() => {
                              openLeaderBoard(item);
                            }}
                            className={"angle_btn " + props.landingType}
                          >
                            {__("Leaderboards")}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="red"
                              class="bi bi-arrow-right"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </section>
                  </div>
                ))}
              </>
            ) : (
              <>
                <NoRecordsFound />
              </>
            )}
          </div>
        </div>
      </div>
      <section className="race_list_v1 leaderboard_v1 padding_top_25 d-none">
        {races.length ? (
          <>
            {races.map((item, index) => (
              <>
                <div className="single_race_item">
                  <div className="race_date">
                    {moment(item.expiry_date, "YYYY-MM-DD HH:mm:ss").format(
                      "MMMM Do YYYY, hh:mm:ss A"
                    )}
                  </div>

                  <div className="leaderbord_content single_race_body">
                    <div className="leaderboard_games">
                      <div className="leaderboard_image">
                        {item.race_banner ? (
                          <img
                            className=""
                            src={item.race_banner}
                            alt="Genie Jackpot "
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="leaderboard_text">
                      <div className="info_btn">
                        <OverlayTrigger
                          overlay={
                            <Tooltip>
                              {/* {item.lang?.campaign_information} */}
                              {renderHTML(item.lang?.description)}
                            </Tooltip>
                          }
                        >
                          <svg
                            width="31"
                            height="30"
                            viewBox="0 0 31 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.4994 0C7.21619 0 0.5 6.71619 0.5 14.9994C0.5 23.2825 7.21619 30 15.4994 30C23.7825 30 30.5 23.2825 30.5 14.9994C30.5 6.71619 23.7825 0 15.4994 0ZM18.6219 23.247C17.8498 23.5517 17.2352 23.7829 16.7743 23.9429C16.3146 24.1029 15.78 24.1829 15.1717 24.1829C14.2371 24.1829 13.5095 23.9543 12.9914 23.4984C12.4733 23.0425 12.2156 22.4648 12.2156 21.7625C12.2156 21.4895 12.2346 21.2102 12.2727 20.9257C12.3121 20.6413 12.3743 20.3213 12.4594 19.9619L13.4257 16.5486C13.5108 16.221 13.5844 15.9098 13.6429 15.6203C13.7013 15.3283 13.7292 15.0603 13.7292 14.8165C13.7292 14.3822 13.639 14.0775 13.46 13.906C13.2784 13.7346 12.9368 13.6508 12.4276 13.6508C12.1787 13.6508 11.9222 13.6876 11.6594 13.7651C11.399 13.8451 11.173 13.9175 10.9876 13.9886L11.2429 12.9371C11.8752 12.6794 12.481 12.4584 13.0587 12.2756C13.6365 12.0902 14.1825 11.9987 14.6968 11.9987C15.6251 11.9987 16.3413 12.2248 16.8454 12.6717C17.347 13.12 17.5997 13.7029 17.5997 14.419C17.5997 14.5676 17.5819 14.8292 17.5476 15.2025C17.5133 15.5771 17.4486 15.9187 17.3546 16.2324L16.3933 19.6356C16.3146 19.9086 16.2448 20.221 16.1813 20.5702C16.119 20.9194 16.0886 21.186 16.0886 21.3651C16.0886 21.8171 16.1889 22.1257 16.3921 22.2895C16.5927 22.4533 16.9444 22.5359 17.4422 22.5359C17.6771 22.5359 17.94 22.494 18.2371 22.4127C18.5317 22.3314 18.7451 22.259 18.8797 22.1968L18.6219 23.247ZM18.4517 9.43365C18.0035 9.85016 17.4638 10.0584 16.8327 10.0584C16.2029 10.0584 15.6594 9.85016 15.2073 9.43365C14.7578 9.01714 14.5305 8.51048 14.5305 7.91873C14.5305 7.32825 14.759 6.82032 15.2073 6.4C15.6594 5.97841 16.2029 5.76889 16.8327 5.76889C17.4638 5.76889 18.0048 5.97841 18.4517 6.4C18.9 6.82032 19.1248 7.32825 19.1248 7.91873C19.1248 8.51175 18.9 9.01714 18.4517 9.43365Z"
                              fill="#4DE8FF"
                            />
                          </svg>
                        </OverlayTrigger>
                      </div>

                      <div className="leaderboard_text_area">
                        <div className="headline">{item.lang?.title}</div>
                        <div className="title small bold">
                          {item.lang?.campaign_information}
                        </div>
                        {item.ending_in ? (
                          <>
                            <div className="countdown">
                              <div className="ending_text">
                                {__("ENDING IN")}
                              </div>
                              <div className="ending_clock">
                                <RemainingTime
                                  timestamp={item.ending_in}
                                  endTime={new Date(item.expiry_date)}
                                />
                              </div>
                              <div className="ending_text">
                                {__("MIN BET")} : ${item.minimum_wager}
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="title small">
                              {__("The race has")}
                            </div>
                            <div className="title colored">
                              {__("Finished")}
                            </div>
                            <div className="title uppercase small">
                              {__("MIN BET")} : ${item.minimum_wager}
                            </div>
                          </>
                        )}

                        <div className="leaderbook_link">
                          <Link
                            className="commonBtn filledBtn"
                            onClick={() => {
                              openLeaderBoard(item);
                            }}
                          >
                            {__("View Leaderboard")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))}
          </>
        ) : (
          <>
            <NoRecordsFound />
          </>
        )}
      </section>
      <Modal size="lg" show={showDetails} centered>
        <Modal.Body className="cashier_modal">
          <div>
            <Link
              to="#"
              className="modal_close"
              onClick={() => {
                setShowDetails(false);
              }}
            >
              <svg
                width="19"
                height="19"
                className="close-button__IconClose-sc-1o0pd70-1 bMKQZK"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <title>{__("close")}</title>
                <path d="M18.984 6.422L13.406 12l5.578 5.578-1.406 1.406L12 13.406l-5.578 5.578-1.406-1.406L10.594 12 5.016 6.422l1.406-1.406L12 10.594l5.578-5.578z"></path>
              </svg>
            </Link>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(campaignDetails?.lang?.description),
              }}
            ></div>
            <div>
              <h4>{__("Games supported in the race")}</h4>
              <div className="details_games game_list">
                {campaignGames.map((game, index) => (
                  <GameItem game={game} />
                ))}
              </div>
              {pagination && (
                <>
                  <LoadMore data={pagination} onPageChange={onPageChange} />

                  <div className="gameLoadingProgress">
                    <div className="gameLoadingInfo">
                      {__("You've viewed")} {gameLoaded} {__("of")} {totalGame}{" "}
                      {__("games")}
                    </div>
                    <ProgressBar
                      variant="success"
                      now={(gameLoaded / totalGame) * 100}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="main_popup" centered show={showLeaderBoard}>
        <Modal.Body>
          <div className="modalHeader">
            <div className="logo">
              <img
                src={require("../assets/images/new-landing/logo.png").default}
                alt="Card-Icon"
              />
            </div>
            <div
              onClick={() => {
                setShowLeaderBoard(false);
              }}
              className="close_button"
              closeButton
            >
              <i className="far fa-times"></i>
            </div>
          </div>
          <div className="legal_area">
            <br />
            <Table variant="dark">
              <thead>
                <tr>
                  <td>#</td>
                  <td>{__("Player")}</td>
                  <td>{__("Wagered")}</td>
                  <td>{__("Cash Reward")}</td>
                  <td>{__("Bonus")}</td>
                </tr>
              </thead>

              <tbody>
                {leaderBoard.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.player_name}</td>
                    <td>${item.wagered}</td>
                    <td>${item.cash_prize}</td>
                    <td>${item.bonus}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
